import muiIcons from "../../../components/icons/mui-icons";

export const tableDataList = [
  {
    name: "Smith Doe",
    email: "Smith@gmail.com",
    status: "active",
    photoUrl: "/assets/images/faces/1.jpg",
  },
  {
    name: "Jhon Doe",
    email: "Jhon@gmail.com",
    status: "pending",
    photoUrl: "/assets/images/faces/2.jpg",
  },
  {
    name: "Alex",
    email: "Otttio@gmail.com",
    status: "inactive",
    photoUrl: "/assets/images/faces/3.jpg",
  },
  {
    name: "Mathew Doe",
    email: "matheo@gmail.com",
    status: "active",
    photoUrl: "/assets/images/faces/1.jpg",
  },
];

export const userActivityList = [
  {
    activitylist: [
      {
        title: "Pages / Visit",
        count: 2065,
      },
      {
        title: "New user",
        count: 465,
      },
      {
        title: "Last week",
        count: 23456,
      },
    ],
  },
  {
    activitylist: [
      {
        title: "Pages / Visit",
        count: 435,
      },
      {
        title: "New user",
        count: 5435643,
      },
      {
        title: "Last week",
        count: 45435,
      },
    ],
  },
  {
    activitylist: [
      {
        title: "Pages / Visit",
        count: 545,
      },
      {
        title: "New user",
        count: 54353,
      },
      {
        title: "Last week",
        count: 4643,
      },
    ],
  },
];

export const productCardData = [
  {
    title: "Wireless Headphone E23",
    description: "Lorem ipsum dolor sit amet consectetur.",
    prevPrice: 500,
    currentPrice: 450,
    imgUrl: "/assets/images/products/headphone-4.jpg",
  },
  {
    title: "Wireless Headphone Y902",
    description: "Lorem ipsum dolor sit amet consectetur.",
    prevPrice: 500,
    currentPrice: 200,
    imgUrl: "/assets/images/products/headphone-3.jpg",
  },
  {
    title: "Wireless Headphone E09",
    description: "Lorem ipsum dolor sit amet consectetur.",
    prevPrice: 500,
    currentPrice: 600,
    imgUrl: "/assets/images/products/headphone-2.jpg",
  },
  {
    title: "Wireless Headphone X89",
    description: "Lorem ipsum dolor sit amet consectetur.",
    prevPrice: 500,
    currentPrice: 350,
    imgUrl: "/assets/images/products/headphone-4.jpg",
  },
];

export const topTitleCardData = [
  {
    Icon: muiIcons.PersonIcon,
    title: "New Leads",
    count: 205,
  },
  {
    Icon: muiIcons.HandCoinIcon,
    title: "Sales",
    count: 4021,
  },
  {
    Icon: muiIcons.CheckOutIcon,
    title: "Checkout",
    count: 80,
  },
  {
    Icon: muiIcons.MoneyIcon,
    title: "Expense",
    count: 120,
  },
];
